<template>
  <div class="w-full">
    <h3 class="!mt-0 !mb-2.5 !text-[20px] !font-semibold">
      Typy Dnia
    </h3>
    <div class="flex flex-col gap-2">
      <a v-for="post in posts" :href="post.link" :title="post.title"
          class="group no-default-style relative h-[88px] flex items-center rounded-zt border border-zt-light 
               bg-[#283344] zt-hover"
          :class="[post.category === 'Klasyfikacja' ? 
            'bg-[url(/wp-content/themes/zawodtyper/assets/images/klasyfikacja-tlo.png)] bg-center bg-cover' : '']">
        <template v-if="post.category === 'Typy dnia'">
          <div class="w-[85px] h-full rounded-l-zt bg-zt-light/30 flex flex-col items-center justify-center border-r
                    border-zt-light">
            <span class="text-sm font-light">Typów</span>
            <span class="font-semibold">{{ post.comment_count }}</span>
          </div>
          <div class="flex flex-col grow pl-3.5 justify-center h-full rounded-r-zt">
            <span class="uppercase">{{ getDate(post.daily_bets_date) }}</span>
            <span class="capitalize font-light text-[#A6B0BD]">{{ getWeekday(post.daily_bets_date) }}</span>
          </div>
          <svg class="absolute top-1/2 -translate-y-1/2 right-2 transition-transform fill-[#93A3BA]
                      group-hover:translate-x-1 xl:right-3.5" width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.728153 0.220341C0.797822 0.150496 0.880585 0.0950816 0.971703 0.057272C1.06282 0.0194623 1.1605 0 1.25915 0C1.3578 0 1.45549 0.0194623 1.5466 0.057272C1.63772 0.0950816 1.72048 0.150496 1.79015 0.220341L10.7902 9.22034C10.86 9.29001 10.9154 9.37277 10.9532 9.46389C10.991 9.55501 11.0105 9.65269 11.0105 9.75134C11.0105 9.84999 10.991 9.94767 10.9532 10.0388C10.9154 10.1299 10.86 10.2127 10.7902 10.2823L1.79015 19.2823C1.64932 19.4232 1.45832 19.5023 1.25915 19.5023C1.05999 19.5023 0.868983 19.4232 0.728153 19.2823C0.587323 19.1415 0.508206 18.9505 0.508206 18.7513C0.508206 18.5522 0.587323 18.3612 0.728153 18.2203L9.19865 9.75134L0.728153 1.28234C0.658308 1.21267 0.602894 1.12991 0.565084 1.03879C0.527275 0.947674 0.507812 0.849992 0.507812 0.751341C0.507812 0.65269 0.527275 0.555008 0.565084 0.46389C0.602894 0.372773 0.658308 0.290009 0.728153 0.220341V0.220341Z" fill="#93A3BA"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.72815 0.220341C6.79782 0.150496 6.88058 0.0950816 6.9717 0.057272C7.06282 0.0194623 7.1605 0 7.25915 0C7.3578 0 7.45549 0.0194623 7.5466 0.057272C7.63772 0.0950816 7.72048 0.150496 7.79015 0.220341L16.7902 9.22034C16.86 9.29001 16.9154 9.37277 16.9532 9.46389C16.991 9.55501 17.0105 9.65269 17.0105 9.75134C17.0105 9.84999 16.991 9.94767 16.9532 10.0388C16.9154 10.1299 16.86 10.2127 16.7902 10.2823L7.79015 19.2823C7.64932 19.4232 7.45832 19.5023 7.25915 19.5023C7.05999 19.5023 6.86898 19.4232 6.72815 19.2823C6.58732 19.1415 6.50821 18.9505 6.50821 18.7513C6.50821 18.5522 6.58732 18.3612 6.72815 18.2203L15.1987 9.75134L6.72815 1.28234C6.65831 1.21267 6.60289 1.12991 6.56508 1.03879C6.52727 0.947674 6.50781 0.849992 6.50781 0.751341C6.50781 0.65269 6.52727 0.555008 6.56508 0.46389C6.60289 0.372773 6.65831 0.290009 6.72815 0.220341V0.220341Z" fill="#93A3BA"/>
          </svg>
        </template>
        <div v-else class="px-3.5 text-sm font-light leading-[22px]">{{ post.title }}</div>
      </a>
    </div>
  </div>
</template>

<script>
import utils_mixin from '../mixins/utils_mixin';

export default {
  name: 'DailyBets',
  inject: ['WP'],
  mixins: [utils_mixin],
  data() {
    return {
      posts: null,
    }
  },
  created() {
    axios
      .post(this.WP.ajaxUrl, {
        endpoint: 'api_get_daily_bets_posts',
        category_ids: '12, 804',
        count: 4,
        comments: true,
        only_bets: true,
      })
      .then(response => {
        if (response.data.success) {
          this.posts = response.data.data;
        }
      });
  },
  methods: {
    getDate(date) {
      return this.DateTime.fromSQL(date).toFormat('d LLL yyyy');
    },
    getWeekday(date) {
      return this.DateTime.fromSQL(date).weekdayLong;
    },
  },
};
</script>